/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Mantine
import { Box, ActionIcon, Text } from '@mantine/core';

// Styles
import classes from './Header.module.css';

// Icons
import { IconBell } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { HeaderUserMenu } from '@components/molecules/HeaderUserMenu';
import AvatarImage from '@assets/images/eskimo.png';
import { NOT_APPLICABLE } from '@config/constants/common';
import { useLocalStorage } from '@hooks/useLocalStorage';
import {
	findPriorityRole,
	useAuthorization,
} from '@lib/authorization';
import { ROLES } from '@config/constants/roles';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const Header = (props: {
	label: string;
	user: any;
	id?: string;
	onLogout: () => void;
}) => {
	/* ******************************** CONSTANTS ******************************* */
	const firstName = `${props.user?.firstName || NOT_APPLICABLE}`;

	const lastName = `${
		props.user?.lastName || NOT_APPLICABLE
	}`;

	const email = `${props.user?.email || NOT_APPLICABLE}`;

	/* ******************************** HOOKS ******************************* */
	const { t, i18n } = useTranslation();
	const { checkAccess } = useAuthorization();
	const [, setLng] = useLocalStorage('lng', 'en');

	/* ******************************** RENDERING ******************************* */
	return (
		<Box className={classes.container}>
			<Text className={classes.title} size={'h1'}>
				{t(props.label)}
			</Text>
			{props.user && (
				<Box className={classes.containerRight}>
					{checkAccess({
						allowedRoles: [
							ROLES.ADMIN,
							ROLES.SUPERADMIN,
							ROLES.STAFF,
						],
					}) && (
						<ActionIcon
							variant="light"
							size={'lg'}
							color="blue"
							disabled
						>
							<IconBell
								style={{ width: '60%', height: '60%' }}
								stroke={2}
								className={classes.notifications}
							/>
						</ActionIcon>
					)}
					<HeaderUserMenu
						email={email}
						image={
							props?.user?.avatar
								? props.user.avatar
								: AvatarImage
						}
						firstname={firstName}
						lastname={lastName}
						role={
							props.user && props.user.roles
								? findPriorityRole(props.user.roles)?.role
								: NOT_APPLICABLE
						}
						onChangeLanguage={(_language) => {
							i18n.changeLanguage(_language);
							setLng(_language);
						}}
						language={props.user.locale.language}
						onLogout={props.onLogout}
					/>
				</Box>
			)}
		</Box>
	);
};
